(() => {
    class Observer {
        /* OBSERVER
         * This is the main file to observe the entire APP. */
        constructor(instance) {
            this.instance   = instance;
            this._objects   = [];
            this._functions = [];
        }
        /**
         * Register an observer.
         * @param observer object The object that's updated when the model changes.
         * @return this
         */
        register(observer) {
            switch (typeof observer) {
                case "object":
                    if (this._objects.indexOf(observer) === -1)
                        this._objects.push(observer);
                    break;
                case "function":
                    if (this._functions.indexOf(observer) === -1)
                        this._functions.push(observer);
                    break;
                default:
                    console.log('No case for ' + typeof observer);
            }
            return this;
        }
        /**
         * Remove an observer.
         * @param observer object The object that should be removed as observer.
         * @return this
         */
        remove(observer) {
            const index = this._objects.indexOf(observer);
            this._objects.splice(index, 1);
            return this;
        }
        /**
         * Notifies all registered observers that the model has been changed.
         * @return this
         */
        notify() {
            // Run functions
            for (let key in this._functions) {
                this._functions[key]();
            }
            // Run objects
            for (let key in this._objects) {
                this._objects[key].update(this.instance);
            }
            return this;
        }
    }
    App.Entities.Observer = Observer;
})();
